module.exports = __webpack_public_path__ + "static/media/ms-symbollockup_signin_light.ad23a60a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms-symbollockup_signin_light.svg
// module id = 1754
// module chunks = 0